module.exports = function (app) {

    app.controller('pages.forgotPassword.step1', ["$state", "$scope", "$http", "$cookies", "coremetrics", "teamsite", "userService", "brand", "$window",
        function ($state, $scope, $http, $cookies, coremetrics, teamsite, userService, brand, $window) {

            var stateError = $state.params.error;
            var allowSubmit = false;

            $scope.headings = "Forgot Username or Password";
            $scope.showModal = false;
            $scope.chevron.step = 1;
            $scope.userSelection = '';
            $scope.memberSelected = false;
            $scope.producerSelected = false;
            $scope.agencySelected = false;
            $scope.planAdminSelected = false;
            $scope.visitorSelected = false;
            $scope.$parent.verificationSuccess = null;
            $scope.$parent.serviceData.payload = null;
            $scope.member = {id: '', firstName: '', dob: ''};
            $scope.memberId = "";
            $scope.producer = {agentEmail: ''};
            $scope.agency = {firstName: '', lastName: '', agencyNumber: ''};
            $scope.visitor = {firstName: '', lastName: '', emailAddress: '', dob: ''};

            $scope.isMN = brand.current.ubk === 6010;
            $scope.isND = brand.current.ubk === 6011;
            $scope.isWY = brand.current.ubk === 6012;

            $scope.submitAttempts = {};
            $scope.footerMessage = {
                header: "",
                message: "",
                iconClass: "",
                show: false
            };

            // Update Chevron on initialize of step1.
            $scope.$parent.updateChevron(1, false);

            $scope.phoneNumber = "the number on the back of your member ID card.";
            if ($scope.brandData.sharedBrandCode.toUpperCase() === "PP") {
                $scope.phoneNumber = "1-877-298-3918";
            } else if ($scope.brandData.phoneNumbers && $scope.brandData.phoneNumbers.technical) {
                $scope.phoneNumber = $scope.brandData.phoneNumbers.technical;
            }

            $scope.radioButtonClick = function (selection) {
                $scope.footerMessage.show = false;
                allowSubmit = true;
                resetForms();

                switch (selection) {
                    case "member":
                        $scope.memberSelected = true;
                        $scope.producerSelected = false;
                        $scope.agencySelected = false;
                        $scope.planAdminSelected = false;
                        $scope.visitorSelected = false;
                        break;
                    case "producer":
                        $scope.memberSelected = false;
                        $scope.producerSelected = true;
                        $scope.agencySelected = false;
                        $scope.planAdminSelected = false;
                        $scope.visitorSelected = false;
                        break;
                    case "agency":
                        $scope.memberSelected = false;
                        $scope.producerSelected = false;
                        $scope.agencySelected = true;
                        $scope.planAdminSelected = false;
                        $scope.visitorSelected = false;
                        break;
                    case "plan":
                        $scope.memberSelected = false;
                        $scope.producerSelected = false;
                        $scope.agencySelected = false;
                        $scope.planAdminSelected = true;
                        $scope.visitorSelected = false;
                        break;
                    case "visitor":
                        $scope.memberSelected = false;
                        $scope.producerSelected = false;
                        $scope.agencySelected = false;
                        $scope.planAdminSelected = false;
                        $scope.visitorSelected = true;
                        break;
                    default:
                        $scope.memberSelected = false;
                        $scope.producerSelected = false;
                        $scope.agencySelected = false;
                        $scope.planAdminSelected = false;
                        $scope.visitorSelected = false;
                }
                // Fixes a weird bug with ie8 not repainting
                // This is bad practice, there must be a better way to fix this
                var element = $('body')[0];
                element.className = element.className;
            };


            $scope.$watch('member', function (newVal, oldVal, scope) {
                allowSubmit = true;
            }, true);

            $scope.$watch('visitor', function (newVal, oldVal, scope) {
                allowSubmit = true;
            }, true);

            $scope.nextStep = function (screen) {
                if ($scope.forgottenPasswordForm.$valid && allowSubmit === true) {
                    $scope.footerMessage.show = false;
                    allowSubmit = false;

                    if ($scope.userSelection && $scope.userSelection !== 'plan') {
                        $scope.submitAttempts[$scope.userSelection] = ($scope.submitAttempts[$scope.userSelection] ? $scope.submitAttempts[$scope.userSelection] + 1 : 1);
                        $scope.disabledButton = true;

                        var payload = userService.getIdentifyUserPayload($scope.userSelection, $scope.$parent.isAccountRecoveryActive, $scope);
                        $scope.$parent.payload = payload;

                        //call service
                        userService.identifyUser($scope.userSelection, $scope.$parent.isAccountRecoveryActive, payload).then(function (response) {
                            $scope.disabledButton = false;
                            //$scope.$parent.serviceData = response.data;
                            window.scrollTo(0, 0);

                            // Finish Step 1 conversion event
                            coremetrics.finishConversion('STEP 1 PERSONAL INFORMATION', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

                            //go to next page
                            if ($scope.$parent.isAccountRecoveryActive && ($scope.userSelection === 'member' || $scope.userSelection === 'visitor')) {
                                $scope.$parent.serviceData = response;
                                $scope.$parent.goto(2, true, response);
                                $scope.$parent.updateChevron(2, true);
                            } else {
                                $scope.$parent.serviceData = response.data;
                                $scope.$parent.goto(2, false);
                                $scope.$parent.updateChevron(2, false);
                            }

                        }, function (error) {
                            // console.debug('error', error);
                            $scope.disabledButton = false;

                            if (error && error.data && error.data.baseMessage && (error.data.baseMessage.returnCodeDescription === 'GEN-NOMATCHFORGOTTEN' ||
                                error.data.baseMessage.businessContext === "MEMBER_NOTFOUND" ||
                                error.data.baseMessage.businessContext === "VISITOR_NOTFOUND" ||
                                error.data.baseMessage.returnCodeDescription === "Brand conflict")) {

                                var attempts = $scope.submitAttempts[$scope.userSelection];

                                if ($scope.userSelection === 'member') {
                                    if ($scope.isMN) {
                                        showFooterMessageWithAttempts("We’re sorry, the information you entered does not match our records.", "Please check the information you entered.", true, attempts);
                                    } else {
                                        showFooterMessageWithAttempts("YOUR ENTRY DOES NOT MATCH OUR RECORDS", "Check that the information you entered is correct.", true, attempts);
                                    }
                                }else {
                                    showFooterMessageWithAttempts("", "Your entry does not match our records.", true, attempts);
                                }
                            } else {
                                showGeneralErrorMessage();
                                allowSubmit = true;
                            }
                        });
                    }
                }
            };

            $scope.cancelButton = function () {
                $scope.$parent.payload = "";

                if ($scope.$parent.previousState && $scope.$parent.previousState.length > 0) {
                    // If user came from a defined previous state, take them back after successful account unlock.
                    $state.go($scope.$parent.previousState, $scope.$parent.previousStateParams);
                } else {
                    $window.history.back();
                }
            };


            //TODO: Move this to content. Create a directive for Member ID Card Image.
            $scope.determineIdCard = function () {
                var brand = $scope.brandData.sharedBrandCode.toLowerCase();
                var idCard = "";
                var subDomain = location.hostname.split('.')[0].match(/(.env.?)/);
                if (!subDomain) {
                    subDomain = [''];
                }

                var path = 'https://static' + subDomain[0] + '.hmhs.com/bootstrap/v4/resources/img/idcard/ForgottenPassword/';
                switch (brand) {
                    case "hmbcbsde":
                        idCard = path + "Sample-IDcard_DE.png";
                        break;
                    case "mn":
                        idCard = path + "Sample-IDcard_MN-nationalAlliance.png";
                        break;

                    case "mincr":
                        idCard = path + "Sample-IDcard_MN-ASP.png";
                        break;
                    case "hmbcbswv":
                        idCard = path + "Sample-IDcard_WV.png";
                        break;
                    case "hbs":
                        idCard = path + "Sample-IDcard_HMBS.png";
                        break;
                    case "pp":
                        idCard = path + "Sample-IDcard_planPartners.png";
                        break;
                    case "ndbcbs":
                        idCard = path + "Sample-IDcard_ND-ASP.png";
                        break;
                    case "wybcbs":
                        idCard = path + "Sample-IDcard_WY-ASP.png";
                        break;
                    default:
                        idCard = path + "Sample-IDcard_BCBS.png";
                        break;
                }
                return idCard;
            };
            $scope.idCard = $scope.determineIdCard();

            var resetForms = function () {
                $scope.forgottenPasswordForm.$setUntouched();
                $scope.forgottenPasswordForm.$setPristine();
            };

            var showFooterMessageWithAttempts = function (headerText, messageText, isError, attempts) {
                if (attempts > 3) {
                    messageText = messageText + " For help, call " + $scope.phoneNumber;
                }
                userService.showFooterMessage($scope.footerMessage, headerText, messageText, isError);
            };

            var showGeneralErrorMessage = function () {
                userService.showFooterMessage($scope.footerMessage, "", "We are having trouble processing your request right now. Try again in a few minutes. " +
                    "If the problem continues, please call the number on the back of your member ID card.", true);
            };

            // Check for any error that caused the user to be sent to step1 to start over.
            if (stateError && stateError.code === 404 && stateError.context === 'TOKEN_NOTFOUND') {
                userService.showFooterMessage($scope.footerMessage, "", "You have run out of time to complete all required steps. For security reasons, you must start over.", true);

            } else if (stateError && stateError.code && stateError.code > 0) {
                showGeneralErrorMessage();
            }

            // Start whole flow conversion event
            coremetrics.startConversion('FORGOT USERNAME OR PASSWORD', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');
            // Start step 1 conversion event
            coremetrics.startConversion('STEP 1 PERSONAL INFORMATION', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

        }]);
};